var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcomingRepaymentsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H0V2H18V4H2V19H7V21Z",
    fill: "url(#paint0_linear_3151_4911)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H20V4H18V2H22V21Z",
    fill: "url(#paint1_linear_3151_4911)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H4V6H6V0Z",
    fill: "url(#paint2_linear_3151_4911)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H16V6H18V0Z",
    fill: "url(#paint3_linear_3151_4911)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7H1V9H21V7Z",
    fill: "url(#paint4_linear_3151_4911)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0098 21C12.0209 21 11.0541 20.7067 10.2319 20.1573C9.40963 19.6079 8.76882 18.827 8.39038 17.9134C8.01194 16.9998 7.91291 15.9945 8.10584 15.0245C8.29876 14.0546 8.77498 13.1637 9.47425 12.4645C10.1735 11.7652 11.0644 11.289 12.0343 11.0961C13.0042 10.9032 14.0095 11.0022 14.9232 11.3806C15.8368 11.759 16.6177 12.3999 17.1671 13.2221C17.7165 14.0444 18.0098 15.0111 18.0098 16C18.0098 17.3261 17.483 18.5978 16.5453 19.5355C15.6076 20.4732 14.3358 21 13.0098 21ZM13.0098 13C12.4164 13 11.8364 13.176 11.343 13.5056C10.8497 13.8352 10.4652 14.3038 10.2381 14.852C10.011 15.4001 9.95163 16.0033 10.0674 16.5853C10.1831 17.1672 10.4689 17.7018 10.8884 18.1213C11.308 18.5409 11.8426 18.8266 12.4245 18.9423C13.0064 19.0581 13.6096 18.9987 14.1578 18.7716C14.706 18.5446 15.1745 18.1601 15.5042 17.6667C15.8338 17.1734 16.0098 16.5933 16.0098 16C16.0098 15.2043 15.6937 14.4413 15.1311 13.8787C14.5685 13.3161 13.8054 13 13.0098 13Z",
    fill: "url(#paint5_linear_3151_4911)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.714 18.2831L14.2998 19.6973L17.2979 22.6954L18.7122 21.2812L15.714 18.2831Z",
    fill: "url(#paint6_linear_3151_4911)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4911",
    x1: 9,
    y1: 22.7593,
    x2: 9,
    y2: -0.462965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4911",
    x1: 20,
    y1: 22.7593,
    x2: 20,
    y2: -0.462965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4911",
    x1: 5,
    y1: 6.55556,
    x2: 5,
    y2: -0.777778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4911",
    x1: 17,
    y1: 6.55556,
    x2: 17,
    y2: -0.777778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3151_4911",
    x1: 11,
    y1: 9.18519,
    x2: 11,
    y2: 6.74074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3151_4911",
    x1: 13.0098,
    y1: 21.9259,
    x2: 13.0098,
    y2: 9.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3151_4911",
    x1: 18.2827,
    y1: 22.2659,
    x2: 14.6183,
    y2: 18.6015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingRepaymentsActive);
export default __webpack_public_path__ + "static/media/upcoming-repayments-active.632afe89ac97024904ae6d8b72ec0a2e.svg";
export { ForwardRef as ReactComponent };